module.exports = __webpack_public_path__ + "img/cry.1c5e2905.svg";